const styles = (theme) => ({
	PaperItem: {
		display: "flex",
		flexDirection: "column",
		flexWrap: "wrap",
		margin: "1rem auto",
		maxWidth: "1100px",
		height: "95vh",
	},
	formItems: {
		marginTop: "5rem",
		alignSelf: "center",
		width: "auto",
		marginLeft: "1rem",
	},
	error: {
		marginTop: "1rem",
		textAlign: "center",
		color: "red",
		fontSize: "0.8rem",
	},
	button: {
		position: "relative",
		margin: "2rem 0 2rem 4rem",
		width: "5rem",
		alignSelf: "center",
		display: "block",
	},
});
export default styles;
